import React from 'react';
import { connect } from 'react-redux';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';
import AwaitAccountConfirmation from '../Components/AwaitAccountConfirmation';

const AwaitAccountConfirmationPage = ({ user, config, cmsSourceFirebase, actions, match }) => {
    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, match }}>
            <AwaitAccountConfirmation />
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(AwaitAccountConfirmationPage);
